/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResultDto,
} from '../models/index';
import {
    ResultDtoFromJSON,
    ResultDtoToJSON,
} from '../models/index';

/**
 * 
 */
export class ProfitCentersApi extends runtime.BaseAPI {

    /**
     */
    async profitCentersControllerGetProfitCentersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/profit-centers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async profitCentersControllerGetProfitCenters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.profitCentersControllerGetProfitCentersRaw(initOverrides);
        return await response.value();
    }

}
